import React from 'react';

interface FloatingActionButtonProps {
    onClick: () => void; 
  }
  const FloatingActionButton: React.FC<FloatingActionButtonProps> = ({ onClick }) => {
  return (
    <button 
      onClick={onClick}
      // className="fixed inset-x-0 bottom-0 mb-4 mx-auto bg-indigo-600 text-white w-14 h-14 rounded-full  grid place-items-center"
    >
      {/* Load */}
    </button>
  );
}

export default FloatingActionButton;